// removed by extract-text-webpack-plugin
module.exports = {"ChessBtn":"ChessLink__ChessBtn___1oElx","Show1024":"ChessLink__Show1024___aLtmk","Hide1024":"ChessLink__Hide1024___wUxUV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Main/ChessLink/ChessLink.scss
// module id = 1289
// module chunks = 0